import { Accordion as ReachAccordion } from '@reach/accordion';

import IAccordion from './types';

import '@reach/accordion/styles.css';

function Accordion({ className, children, collapsible = true, multiple = false }: IAccordion) {
  return (
    <ReachAccordion className={className} collapsible={collapsible} multiple={multiple}>
      {children}
    </ReachAccordion>
  );
}

export default Accordion;
